import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "credit-card"
}
const _hoisted_2 = { class: "credit-card__brand" }
const _hoisted_3 = { class: "credit-card__last4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "credit-card__dots--dot" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "credit-card__dots--dot" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "credit-card__info" }
const _hoisted_8 = { class: "credit-card__info--slot" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Cardholder Name", -1)
const _hoisted_10 = { class: "link-button" }
const _hoisted_11 = { class: "credit-card__info--slot" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Expiration Date", -1)
const _hoisted_13 = { class: "link-button" }
const _hoisted_14 = {
  key: 1,
  class: "no-credit-card"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", { class: "c-secondary-black" }, [
  /*#__PURE__*/_createElementVNode("b", null, "No card applied")
], -1)
const _hoisted_16 = {
  key: 2,
  class: "credit-card__loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconsCardBrand = _resolveComponent("IconsCardBrand")!
  const _component_IconNoCreditCard = _resolveComponent("IconNoCreditCard")!

  return (_ctx.$props.card && !_ctx.$props.loader)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_IconsCardBrand, {
            brand: _ctx.$props.card.brand
          }, null, 8, ["brand"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (dot) => {
            return _createElementVNode("div", {
              class: "credit-card__dots",
              key: dot
            }, _hoisted_6)
          }), 64)),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$props.card.last4), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$props.card.cardholder_name), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.formattingExpirationDate(_ctx.$props.card)), 1)
          ])
        ])
      ]))
    : (!_ctx.$props.card && !_ctx.$props.loader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_IconNoCreditCard),
          _hoisted_15
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16))
}